import styled from 'styled-components/macro';

export const Container = styled.div`
  max-width: 1262px;
  width: 100%;
`;
